var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcoExpereinceDesign(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 4.66667C9.18405 4.66667 9.33329 4.51743 9.33329 4.33333C9.33329 4.14924 9.18405 4 8.99996 4C8.81586 4 8.66663 4.14924 8.66663 4.33333C8.66663 4.51743 8.81586 4.66667 8.99996 4.66667Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 7.33341C11.8508 7.33341 12 7.18418 12 7.00008C12 6.81599 11.8508 6.66675 11.6667 6.66675C11.4826 6.66675 11.3334 6.81599 11.3334 7.00008C11.3334 7.18418 11.4826 7.33341 11.6667 7.33341Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66671 5.33341C5.8508 5.33341 6.00004 5.18418 6.00004 5.00008C6.00004 4.81599 5.8508 4.66675 5.66671 4.66675C5.48261 4.66675 5.33337 4.81599 5.33337 5.00008C5.33337 5.18418 5.48261 5.33341 5.66671 5.33341Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 8.66667C4.51743 8.66667 4.66667 8.51743 4.66667 8.33333C4.66667 8.14924 4.51743 8 4.33333 8C4.14924 8 4 8.14924 4 8.33333C4 8.51743 4.14924 8.66667 4.33333 8.66667Z",
    fill: "#057DCD",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 1.33325C4.33337 1.33325 1.33337 4.33325 1.33337 7.99992C1.33337 11.6666 4.33337 14.6666 8.00004 14.6666C8.61737 14.6666 9.09871 14.1693 9.09871 13.5413C9.09871 13.2499 8.97871 12.9846 8.80737 12.7913C8.61404 12.5986 8.51537 12.3566 8.51537 12.0413C8.51285 11.8945 8.53988 11.7488 8.59487 11.6127C8.64986 11.4767 8.73168 11.3531 8.83544 11.2493C8.93921 11.1456 9.0628 11.0637 9.19886 11.0087C9.33491 10.9538 9.48065 10.9267 9.62737 10.9293H10.958C12.992 10.9293 14.6614 9.26059 14.6614 7.22659C14.6434 4.00792 11.6407 1.33325 8.00004 1.33325Z",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoExpereinceDesign);
export default __webpack_public_path__ + "static/media/eco-expereince-design.904d57c14bd991876e101d3fb058199b.svg";
export { ForwardRef as ReactComponent };